(function($) {
  $(document).ready(function() {
    if (!$('body').hasClass('template-product')) return;

    const selector = ".shopify_subscriptions_app_block_label_children li label";

    function truncateTextNodesBeforeComma($label) {
      // Get all text nodes inside the label
      const textNodes = [];
      $label.contents().each(function() {
        if (this.nodeType === Node.TEXT_NODE) {
          textNodes.push(this);
        } else {
          // Recursively check inside children
          $(this).contents().each(function() {
            if (this.nodeType === Node.TEXT_NODE) {
              textNodes.push(this);
            }
          });
        }
      });

      let foundComma = false;
      textNodes.forEach(function(tn) {
        if (foundComma) {
          tn.nodeValue = "";
          return;
        }
        const idx = tn.nodeValue.indexOf(',');
        if (idx !== -1) {
          tn.nodeValue = tn.nodeValue.slice(0, idx).trimEnd();
          foundComma = true;
        }
      });
    }

    function cleanAllLabels() {
      $(selector).each(function() {
        truncateTextNodesBeforeComma($(this));
      });
    }

    cleanAllLabels();

    let scheduled = null;
    const observer = new MutationObserver(function() {
      if (scheduled) clearTimeout(scheduled);
      scheduled = setTimeout(function() {
        cleanAllLabels();
        scheduled = null;
      }, 100);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    setTimeout(function() {
      $('body').addClass('subscriptions-ready');
      if ($('.shopify_subscriptions_app_block_label').length !== 0) $('.subscription_policy').removeClass('hide');
    }, 300);

  });
})(jQuery);
